import { easyCreditRedirectPath } from 'Modules/easyCredit/routes';

export const platformPaths = {
  EASY_CREDIT: easyCreditRedirectPath,
};
